// extracted by mini-css-extract-plugin
module.exports = {"wrappercookies":"stylecookies_wrappercookies__14rPf"};